import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { setOpenSideBar } from "../redux/slices/appSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  createUserChanels,
  fetchAllChannels,
  fetchUsers,
  resetCreateChannels,
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";

const UserNavRap = styled.div`
  /* background: #060b130a; */
  padding: 17px 34px;
  /* position: fixed;
  z-index: 10000 !important;
  top: 0;
  left: 0px;
  right: 0px; */
  .userNav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .channel {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #bac0d499;
    background: #ffffff;
    position: relative;
    border-radius: 100px;
    padding: 10px 23px;
  }
  .chaneel-drop {
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    position: absolute;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #bac0d499;
    top: 40px;
    right: 20px;
  }
  .chaneel-drop p {
    font-size: 16px;
    color: #ed1c24 !important;
    padding: 10px 20px;

  }
    .chaneel-drop p:hover {
      background: #bac0d499;
    }
  
  .channel p,
  .channel span {
    margin: 0px;
    color: #363d4f;
    font-size: 14px;
    font-weight: 400;
  }
  .channel span {
    color: #ed1c24;
  }
  .upgrade {
    border: 0.7px solid #ed1c24;
    background: #ed1c2412;
    width: 146px;
    height: 40px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: #ed1c24;
    font-size: 14px;
    font-weight: 400;
  }
  .notification {
    background: #ffffff;
    border: 1px solid #bac0d499;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .username {
    background: #ffffff;
    height: 40px;
    width: 177px;
    border-radius: 100px;
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    border: 1px solid #bac0d499;
  }
  .username p {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
  }
  .end-nav-user {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .open-icon-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .open-icon-div img {
    width: 86px;

    height: 26px;
  }

  form input,
  form textarea {
    width: 350px;
    height: 40px;
    border-radius: 12px;
    padding-left: 15px;
    border: 1px solid #bac0d499;
  }
  form textarea {
    padding-top: 20px;
    height: 120px;
  }
  form button {
    width: 100%;
    height: 40px;
    color: #ffffff;
    background: blue;
    border: none;
    border-radius: 12px;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  form label {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

   @media screen and (max-width: 1120px) {

   }
  @media (max-width: 992px) {
    .channel
     {
      display: none;
    }

    .userNav {
      justify-content: space-between;
    }
  }

   @media (max-width: 700px) { 
 .username {
  display: none;
}
   }
  @media (max-width: 490px) {
    .channel {
      flex-wrap: wrap;
    }
    .upgrade-two {
      display: none;
    }
  }
  @media (max-width: 435px) {
    /* .end-nav-user {
      flex-wrap: wrap;
    } */
  }
`;

const UserNav = () => {
  const { openSideBar } = useSelector((state) => state.app);
        const channelName = localStorage.getItem('pluglrUserChannelName'); // or whatever key you're using

  const dispatch = useDispatch();
  const { userData, userAllChannels, channelloading, channelSuccess, loading, error } =
    useSelector((state) => state.userData);
  const [channelCreateDrop, setChannelCreateDrop] = useState(false);
  const [channelDrop, setChannelDrop] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const channels = userAllChannels?.data || []
  console.log(channelSuccess);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);


 useEffect(() => {
if (userAllChannels) {
 localStorage.setItem("pluglrUserChannelName", channels[0]?.name);
  localStorage.setItem("pluglrUserChannelId", channels[0]?.id);
}
  
  }, [userAllChannels]);

  useEffect(() => {
    if (!channelSuccess) return;

    const createdChannel =
      channelSuccess?.data?.channel ||
      channelSuccess?.data ||
      channelSuccess?.channel ||
      channelSuccess;

    const newChannelId =
      createdChannel?.id ??
      createdChannel?._id ??
      channelSuccess?.channelId ??
      channelSuccess?.data?.id ??
      channelSuccess?.id;

    if (newChannelId) {
      localStorage.setItem("pluglrUserChannelId", newChannelId);
    }

    const newChannelName =
      createdChannel?.name ??
      channelSuccess?.data?.name ??
      channelSuccess?.name;

    if (newChannelName) {
      localStorage.setItem("pluglrUserChannelName", newChannelName);
    }
  }, [channelSuccess]);

    useEffect(() => {
    dispatch(fetchAllChannels());
  }, [dispatch]);

   const handleDropChannel = () => {
    setChannelDrop(!channelDrop);
  };

  const handleSelectedChannel = (item) => {

 localStorage.setItem("pluglrUserChannelName", item?.name);
  localStorage.setItem("pluglrUserChannelId", item?.id);
    setChannelDrop(false);

  }

  const handleCreateChannelDrop = () => {
    setChannelCreateDrop(!channelCreateDrop);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createUserChanels(formData));
  };
  const ShowBar = () => {
    dispatch(setOpenSideBar());
  };
  return (
    <UserNavRap>
      <div className="userNav">
          <Icon
            className="icon-admin-menu"
            width="50px"
            height="50px"
            icon={openSideBar ? "prime:times" : "mdi-light:menu"}
            color="black"
            onClick={() => ShowBar()}
          />

        <div className="channel">
          <p>Your channel: </p>
          {userAllChannels ? (
          <span>{channelName}</span>
          ) : "" }
          {/* <Icon
            icon="tabler:copy"
            width="16"
            height="16"
            style={{ color: "#363D4F", cursor: "pointer" }}
          /> */}
          <Icon onClick={handleDropChannel}
            icon="iconamoon:arrow-down-2-bold"
            width="20"
            height="20"
            style={{ color: "#363D4F", cursor: "pointer" }}
          />
          {channelDrop &&
          <div className="chaneel-drop">
            {channels?.map((item) => (
              <p onClick={() => handleSelectedChannel(item)}>{item?.name}</p>
            ))}
          </div>
          }
        </div>
        <div className="end-nav-user">
           <button onClick={handleCreateChannelDrop} className="upgrade">
            <img src="/images/up-icon.png" alt="" />
            Create Channel
          </button> 

          <Link className="upgrade upgrade-two">
            <img src="/images/up-icon.png" alt="" />
            Upgrade Plan
          </Link>

          <div className="notification">
            <Icon
              icon="basil:notification-outline"
              width="16"
              height="16"
              style={{ color: "#363D4F", cursor: "pointer" }}
            />
          </div>
          <div className="username">
            <img src="/images/user-img.png" alt="" />
            <p>
              {userData?.data?.lname} {userData?.data?.fname}
            </p>
          </div>
        </div>
      </div>

      {channelCreateDrop ? (
        <div className="dropdown-container">
          <div className="all-dropdown-div ">
            <div className="dropdown-header">
              <h4>Create Channel</h4>
              <Icon
                width="30px"
                height="30px"
                icon="humbleicons:times"
                color="#060B13"
                onClick={() => setChannelCreateDrop(false)}
              />
            </div>
            <form onSubmit={handleSubmit}>
              {/* Name input */}
              <div>
                <label>
                  Name of Channel:
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter channel name"
                  />
                </label>
              </div>

              {/* Description input */}
              <div>
                <label>
                  Description:
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter description"
                  />
                </label>
              </div>

              <button type="submit">
                {channelloading ? (
                  <ClipLoader color="white" size={40} />
                ) : (
                  "Create Channel"
                )}
              </button>
            </form>
          </div>
        </div>
      ) : (
        ""
      )}
      {channelSuccess ? (
        <div className="dropdown-container">
          <div
            style={{
              padding: "20px",
            }}
            className="all-dropdown-div "
          >
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              {channelSuccess?.message}
            </p>
            <button
              onClick={() => dispatch(resetCreateChannels())}
              style={{
                border: "none",
                background: "red",
                width: "100%",
                height: "40px",
              }}
            >
              Exit
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </UserNavRap>
  );
};

export default UserNav;
